module.exports = __webpack_public_path__ + "images/emoji/link.862fb3ac397f46e5532e.png";